import { useTranslation } from 'react-i18next'

import classNames from 'classnames'

import 'scss/components/_tag.scss'

interface ITag {
  isRequired?: boolean
  content?: string
  className?: string
}

const Tag = ({ isRequired = false, content = '', className = '' }: ITag) => {
  const { t } = useTranslation()
  return (
    <span
      className={classNames(
        'mcs__tag',
        isRequired ? 'mcs__tag--red' : 'mcs__tag--gray',
        `${className}`,
      )}
    >
      <span>
        {content || t(isRequired ? 'base.required' : 'base.optional')}
      </span>
    </span>
  )
}

export default Tag
